import initSubscribeModal from "@patternlab/source/js/patterns/02-organisms/subscribe-modal-init.js";

const MODAL_HEIGHT = 250;

export default () => {
    const $subscribeModal = $("#subscribeModal");
    const $subscribeModalForm = $subscribeModal.find("div[data-form-id]");
    const currentLanguage = document.documentElement.lang;
    const isMobileScreen = $(window).width() < 480;
    const scrollOffset = () => {
        if (currentLanguage === "cz" && isMobileScreen) {
            return $(document).height() * 0.8 - MODAL_HEIGHT / 2;
        }

        return $(document).height() / 2 - MODAL_HEIGHT / 2;
    };

    initSubscribeModal({
        addScrollEventHandler: $(document).height() > $(window).height() * 1.2,
        scrollOffset: scrollOffset(),
    });

    $subscribeModalForm.on("eset-eloqua-form-submitted", () => {
        setTimeout(() => {
            if (!$subscribeModal.hasClass("closing") && $subscribeModal.is(":visible")) {
                $subscribeModal.modal("hide");
            }
        }, 2500);
    });
};
